


























import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'

import ExportButton from '@/components/molecules/h/ExportButton.vue'
import ExtractCondition from '@/components/organisms/h/page/yosan-haibun/weekly-daily-budget-conf2/ExtractCondition.vue'
import OutputCondition from '@/components/organisms/h/page/yosan-haibun/weekly-daily-budget-conf2/OutputCondition.vue'
import TitleAndManipulate from '@/components/organisms/h/TitleAndManipulate.vue'
import {
  outputCondUseInfoList,
  WeeklyDailyBudgetConfCausalExtractCondition,
  WeeklyDailyBudgetConfCausalOutputCondition,
} from '@/types/entities'
export default defineComponent({
  components: {
    TitleAndManipulate,
    ExtractCondition,
    OutputCondition,
    ExportButton,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
    totalCount: {
      type: String as PropType<string>,
      default: null,
    },
    exportSpinner: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    exportErrorMessage: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(_, context) {
    const instance = getCurrentInstance()
    if (!instance) {
      // should be called in setup
      return
    }
    const { $i18n } = instance.proxy

    const requestExport = () => {
      context.emit('request-export')
    }

    const changeExtractCondition = (
      cond: WeeklyDailyBudgetConfCausalExtractCondition
    ) => {
      console.log('page_view_changeExtractCondition', { cond })
      context.emit('change-extract-condition', cond)
    }
    const changeOutputCondition = (
      cond: WeeklyDailyBudgetConfCausalOutputCondition
    ) => {
      context.emit('change-output-condition', cond)
    }
    return {
      requestExport,
      changeExtractCondition,
      changeOutputCondition,
    }
  },
})
